<!-- Do not change this file. -->

<template>
  <div class="navbar navbar-dark bg-dark">
    <div class="container-fluid">
      <div
        class="navbar-brand d-flex py-0 py-sm-auto align-items-center"
        role="banner"
      >
        <img
          src="@/assets/logo-dark.svg"
          alt="Oregon State University Logo"
          height="30"
          class="d-none d-sm-inline-flex align-top me-3 pe-3 border-end"
        />
        <img
          src="@/assets/logo-dark.svg"
          alt="Oregon State University Logo"
          height="40"
          class="d-inline-flex d-sm-none align-top me-3 pe-3 border-end"
        />
        <div class="d-none d-sm-block title me-3 fw-bold">{{ course }}</div>
        <h1 class="subtitle d-none d-sm-block">{{ title }}</h1>
        <div class="d-flex flex-column d-sm-none align-items-start">
          <div class="title me-3 fw-bold fs-6">{{ course }}</div>
          <h1 class="subtitle fs-6">{{ shortTitle }}</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

import config from "@/data/config";

export default {
  name: "TheHeader",
  data() {
    return {
      course: config.meta.course,
      title: config.meta.title,
      shortTitle: config.meta.shortTitle
    };
  }
};
</script>

<style scoped>
/* Don't apply any bootstrap styling to the h1 elements */
h1 {
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  margin: 0;
}
</style>
